import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "@platform/ui-web/styles.css";
import "./styles/app.css";
import { AppProviders } from "./App";
import { buildRoutes } from "./app/router";

const router = createBrowserRouter(buildRoutes());

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Root container #root not found");
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
